import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { Tokens } from 'types/auth';

type State = {
  id: string | null;
  isAuth: boolean;
  userType: 'owner' | 'customer' | null;
  tokens: null | Tokens;
  client: string | null;
  email: string | null;
  clientId: string | null;
  userId: string | null;
};

const STORAGE_KEY = 'XHIBITHUB-CUSTOMER-SESSION';

const useSessionStore = create(
  persist(
    immer<State>(() => ({
      id: null,
      isAuth: false,
      tokens: null,
      email: null,
      client: null,
      clientId: null,
      userId: null,
      userType: null,
    })),
    {
      name: STORAGE_KEY,
    },
  ),
);

const selectors = {
  useIsAuth: () => useSessionStore((state) => state.isAuth),
  useClientId: () => useSessionStore((state) => state.clientId),
};

const actions = {
  set: useSessionStore.setState,
  // login: () => {
  //   // temp login. replace when API is ready

  //   actions.set((state) => {
  //     state.isAuth = true;
  //   });
  // },
  setSession: ({
    tokens,
    email,
    isAuth = true,
    client,
    clientId,
    userId,
  }: {
    tokens: Tokens;
    email: string;
    isAuth?: boolean;
    client: string;
    clientId: string;
    userId: string;
  }) => {
    const set = useSessionStore.setState;
    set((state) => {
      state.tokens = tokens;
      state.email = email;
      state.isAuth = isAuth;
      state.client = client;
      state.clientId = clientId;
      state.userId = userId;
    });
  },
  setAuth: () => {
    const set = useSessionStore.setState;
    set((state) => {
      state.isAuth = true;
    });
  },
  clearSession: () => {
    const set = useSessionStore.setState;
    set((state) => {
      state.isAuth = false;
      state.tokens = null;
      state.email = null;
      state.userType = null;
      state.id = null;
      state.client = null;
    });
  },
  getClient: () => useSessionStore.getState().client,
  // getters
  getTokens: () => useSessionStore.getState().tokens,
  getToken: () => useSessionStore.getState().tokens?.accessToken,
  getUsername: () => useSessionStore.getState().email,
  getUserId: () => useSessionStore.getState().id,
  getClientId: () => useSessionStore.getState().clientId,
};

/**
 * **Session Store**
 *
 * this store is used to store session tokens
 *
 * **"$"** is a convention to indicate that this is a store
 */
const $session = {
  actions,
  selectors,
} as const;

export default $session;
